import React from 'react';
import BrandLogo from '../../components/BrandLogo';
import LanguageSwitch from '../../components/LanguageSwitch';
import { useMessages } from '../../i18n/I18n';

/** The pieces the sign-in and reset-password screens share */
export const AuthWordmark: React.FC = () => (
  <div className="auth-wordmark">
    <BrandLogo size={36} />
    Festival Systems
  </div>
);

/** The top of the sign-in and reset-password screens: the brand, and the language to read them in */
export const AuthHeader: React.FC = () => (
  <div className="auth-top">
    <AuthWordmark />
    <LanguageSwitch />
  </div>
);

export const AuthFooter: React.FC = () => (
  <footer className="auth-footer">
    <span>© Festival Systems</span>
    <a href="mailto:contact@festival.systems">contact@festival.systems</a>
  </footer>
);

export const AuthArt: React.FC = () => {
  const t = useMessages('auth');
  return (
    <aside className="auth-art" aria-hidden="true">
      <span className="auth-confetti sun-disc" />
      <span className="auth-confetti flame-disc" />
      <span className="auth-confetti raspberry-dash" />
      <span className="auth-confetti leaf-dash" />
      <span className="auth-confetti wave-dot" />
      <span className="auth-confetti sun-dot" />
      <span className="auth-confetti sun-dash" />
      <span className="auth-confetti ring" />
      <div className="auth-art-text">
        <span className="auth-art-title">{t.artTitle}</span>
        <span className="auth-art-subtitle">{t.artSubtitle}</span>
      </div>
    </aside>
  );
};
